import * as React from 'react';
import { League } from '../../../../sdk/model';
import { Card, CardHeader, CardContent, Button } from '@mui/material';
import DraggableList from '../../../util/DraggableList';
import { leagueSeasonApi } from '../../../../adapters/APIExporter';

interface editPlayoffSeedsProps {
  league: League,
  callback: Function
}

function EditPlayoffSeeds(props: editPlayoffSeedsProps) {
  const [orderedTeams, setOrderedTeams] = React.useState(
    [...props.league.teams]
      .sort((team1, team2) => team1.currentSeason?.playoffSeedRank! - team2.currentSeason?.playoffSeedRank!)
      .map(team => {
        return {id : team.id, primary: "#" + team.currentSeason?.playoffSeedRank + ": " + team.name, picture: team.picture, team: team};
      })
  );
  function reorderTeam(destination, source) {
    // dropped outside the list
    if (!destination) return;
    const newOrderedTeams = [...orderedTeams];
    const [removed] = newOrderedTeams.splice(source.index, 1);
    newOrderedTeams.splice(destination.index, 0, removed);
    newOrderedTeams.forEach((team, index) => team.primary = "#" + (index + 1) + ": " + team.team.name)
    setOrderedTeams(newOrderedTeams);
  }
  function submit() {
    const payload = orderedTeams.map((team, teamIndex) => {
      return {seed: teamIndex + 1, teamId: team.id}
    })
    leagueSeasonApi.updatePlayoffSeeds(props.league.id, payload).then(props.callback)
  }
  return <Card style={{maxHeight: 800, overflow: 'auto'}}>
    <CardHeader title="Edit Playoff Seeds" />
    <CardContent>
      <DraggableList items={orderedTeams} onDragEnd={({destination, source}) => reorderTeam(destination, source)} />
      <Button className='capsized-button' onClick={submit}>Save</Button>
      <Button onClick={props.callback}>Cancel</Button>
    </CardContent>
  </Card>
}

export default EditPlayoffSeeds;
